import { customFetch } from '@skytech/auth'
import type {
  Locale,
  Translation,
  PostTranslationPayload,
  UpdateTranslationPayload,
} from '@skytech/types'

import { post } from '@/util/auth'

import { API_ROUTE_TRANSLATIONS, API_ROUTE_TRANSLATION } from './apiRoutes'

const translationResources = {
  getList: () => customFetch<Record<Locale, Translation>>({ path: API_ROUTE_TRANSLATIONS }),

  // mutations
  post: (postTranslationPayload: PostTranslationPayload) =>
    customFetch({ method: 'POST', path: API_ROUTE_TRANSLATIONS, data: postTranslationPayload }),
  update: (updateTranslationPayload: UpdateTranslationPayload) =>
    post(API_ROUTE_TRANSLATION, updateTranslationPayload),
}

export default translationResources
